import script from "./OptionsErrorView.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionsErrorView.vue?vue&type=script&setup=true&lang=js"

import "./OptionsErrorView.vue?vue&type=style&index=0&id=53955378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53955378"]])

export default __exports__